import device from "current-device";
import store from "../store";

export default {
    to(scrollPos) {
        setTimeout(function () {
            let elem = window;
            if (store.state.isApp && device.ios()) {
                elem = document.querySelector('body.ios.app #main > :nth-child(2)');
            }

            elem.scrollTo({
                top: scrollPos,
                left: 0,
                behavior: 'smooth'
            });
        }, 100);
    },
    offsetTopPage(){
        let element = this.getScrollElement();
        return element.scrollTop;
    },
    getScrollElement(){
        let element = null;
        if (device.ios() && store.state.isApp) {
            element = document.querySelector('body.ios.app #main > :nth-child(2)')
        }else{
            element = document.querySelector("html,body");
        }
        return element;
    },
    offsetTop() {
        if (device.ios() && store.state.isApp && document.querySelector("body.ios.app #main aside")) {
            return -document.querySelector("body.ios.app #main aside").getBoundingClientRect().top + 90;
        } else {
            return $(document).scrollTop();
        }
    }
}